export const MIN_INSURANCE_DIFF_PL = 0;
export const MIN_INSURANCE_DIFF_AB = 4;
export const MAX_INSURANCE_DIFF = 364;
